import React, { useEffect, useRef } from "react";

import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, { animationCleanUp } from "./animation";

import assets from "./assets";
import { useTranslation } from "react-i18next";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/Index";
import GoalTemplate from '../GoalAlarmGoal/Index';
import "./style/style.scss";
import "./style/animation.scss";
import { PlayerTriko } from "../../_partials/PlayerTriko/Index";
import getContentById from "../../../../shared/utils/getContentById";
import anime from "animejs";
import PlayerImage from "../../../../shared/components/Image/PlayerImage";
import { getShortPlayerName } from "../../../../shared/feeds/worldcup/playerHelper";
import { getDynamicLogoPath } from "../../../../shared/utils/functions";
import Image from "../../../../shared/components/Image";
import BildPlayerImage from "../../../../shared/components/Image/BildPlayerImage";

const getMainBackground = () => {
    return assets.background_1920;
};

const radius = 30;
const goalRadius = 50;
const width = 929;
const height = 669;
const wholeFieldHeight = height * 2;
const cutoff = height;

function getCssCoord(y, height, r) {
    const ratio = height / 100;

    return y * ratio - r * 2;
}

function getCssBottom(x, r = radius) {
    return getCssCoord(x, wholeFieldHeight, r) - cutoff;
}

function getCssRight(y, r = radius) {
    const value = getCssCoord(y, width, r);
    return value < 0 ? 0 : value;
}

function getSvgX(y, r) {
    return width - getCssRight(y, r) - r;
}

function getSvgY(x, r) {
    return height - getCssBottom(x, r) - r;
}

function getSvgPoint(x, y, r = radius) {
    return `${getSvgX(y, r)},${getSvgY(x, r)}`;
}

export default function Index({ animation, data, mode, format, ...props }) {
    const { t } = useTranslation();
    const id = `bild_goal_alarm_${data?.id}`;
    const playerId = data?.playerId;
    const matchInfo = data?.matchInfo;
    const matchDetails = data?.matchDetails;
    const attackingZones = data?.attackingZones;
    const contestantId = data?.contestantId;
    const contestantTeam = data?.matchInfo?.contestant.find(
        (c) => c.id === contestantId,
    );
    const teamSide = contestantTeam?.position ?? "home";
    // const goalData = data?.goalData?.goal || [];
    const lineUps = data?.goalData?.lineUp || [];
    const goalTeamLineUp = lineUps.find((l) => l.contestantId === contestantId);
    const goalPlayer = goalTeamLineUp.player.find(
        (player) => player.playerId === playerId,
    );

    const competitionId = matchInfo?.competition?.id;

    const matchStatus = matchDetails?.matchStatus;
    const scores = matchDetails?.scores;

    const homeTeam = matchInfo?.contestant?.[0];
    const awayTeam = matchInfo?.contestant?.[1];

    const reversePlayerMapping = _.get(data, "reversePlayerMapping");
    const heimspielMatch = _.get(data, "heimspielMatch");
    const heimspielHome = heimspielMatch?.home;
    const heimspielAway = heimspielMatch?.away;
    const prepareAnimation = () => {
        prepareVideoBg({ id });
    };

    useEffect(() => {
        let animationReturn = null;
        if (mode === "animation" || mode === "video") {
            if (animation) {
                prepareAnimation();
                animationReturn = animationScript({
                    data,
                    animation,
                    mode,
                    id,
                    format,
                    apiSetup: props?.apiSetup,
                });

                animationReturn.timeline.play();
            }
        }

        return function cleanUp() {
            if (animationReturn) {
                animationCleanUp(animationReturn);
            }
        };
    }, [animation, mode]);

    const goalData = data?.goalData?.goalCoordData || [];
    const goal = goalData?.[goalData?.length - 1];
    const goalPos = goal?.coords?.dest;
    const goalEventId = goal?.eventId;


    const latestScore = data?.latestScore || scores?.total;
    const cardRef = useRef(null);
    return (
        <div
            id={id}
            className={`T_bild_goal_alarm ${animation ? "animation" : ""} side-${teamSide}`}
            style={{
                width: '100%',
                height: '100%'
            }}
        >
            <TemplateBlock class="template-transparent">
                {matchStatus && goal && (
                    <div
                        className="wc-content wc-content-v2"
                        style={{ background: "#0A2750", top: 160, borderRadius: 36, left: 60, overflow: "hidden" }}
                    >
                        <div className="main-content-side">
                            <div className="main-header green-glow header-v1 alarm-goal-headline">{t('Goal', { keyPrefix: 'templates' })}!</div>
                            <div className={"center-block-side"}>
                                <div className="player-wrap">
                                    <div className="player-avatar-wrap">
                                        <BildPlayerImage
                                            id={reversePlayerMapping?.[goal?.player?.playerId]}
                                            className="player-avatar"
                                        />
                                    </div>
                                    <div className="player-name">
                                        {getShortPlayerName({
                                            knownName: goalPlayer?.matchName,
                                            ...goalPlayer,
                                        }, false, false)}
                                    </div>
                                </div>
                                <div className={"team-logo-container"}>
                                    <Image
                                        className="team-logo"
                                        src={getDynamicLogoPath({ team: teamSide === "home" ? homeTeam : awayTeam, competitionId })}
                                    />
                                </div>
                                <MatchScoreWidget
                                    homeTeam={homeTeam}
                                    awayTeam={awayTeam}
                                    scores={{
                                        ...scores,
                                        total: latestScore
                                    }}
                                    side={teamSide}
                                    matchStatus={"Playing"}
                                    matchDetails={matchDetails}
                                    competitionId={competitionId}
                                    isAlarm
                                    hideLive={true}
                                />
                                <div className="match-time-wrapper">
                                    <span className={"match-score-time"}>
                                        {data.timeMin} {t("min")}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </TemplateBlock>
        </div>
    );
}
